import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

const loggedInUserKey = 'logged-in-user';


@Injectable({
  providedIn: 'root'
})

export class LoginDetailsService {

  public loggedInUser: Observable<any>;

  private userState = new BehaviorSubject<any>('');

  constructor() {
    this.loggedInUser = this.userState.asObservable();

    const savedDetails = localStorage.getItem(loggedInUserKey) || sessionStorage.getItem(loggedInUserKey);
    if (savedDetails) {
      this.setLoggedInUserDetails(savedDetails);
    } else {
      this.userState.next(null);
    }
  }

  // tslint:disable-next-line:variable-name
  private _loggedInUser: any | null = null;

  get loggedInUserDetails(): any | null {
    let businessType = JSON.parse(localStorage.getItem(loggedInUserKey));
    if (!businessType) {
      businessType = JSON.parse(sessionStorage.getItem(loggedInUserKey));
    }
    if (!businessType) {
      return null;
    }
    return this._loggedInUser;
  }

  setLoggedInUser(user?: any) {


    this._loggedInUser = user || null;

    if (user) {

      localStorage.setItem(loggedInUserKey, JSON.stringify(user));
      sessionStorage.setItem(loggedInUserKey, JSON.stringify(user));
      this.setLoggedInUserDetails(user);

    } else {

      sessionStorage.removeItem(loggedInUserKey);
      localStorage.removeItem(loggedInUserKey);
      this.userState.next(null);
    }
  }

  private setLoggedInUserDetails(title: any) {
    if (!title) {
      return;
    }

    const theUser: any = title;

    this.userState.next(theUser);
    this._loggedInUser = theUser;

  }

}
